import {
    Component,
    OnInit,
    ViewEncapsulation,
    ViewContainerRef
} from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Router
} from '@angular/router';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    NgForm,
    FormsModule,
    Validators,
    AbstractControl
} from '@angular/forms';
import { Helpers } from '../../../../../../helpers';
import { ValidationService } from '../../../../../../_services/validation.service';
import { SweetAlertService } from '../../../../../../_services/sweetalert.service';
import { BaseComponent } from '../../../base.component';
import { CustomerService } from '../../../../../../services/customer.service';
import { Customer } from '../../../../../../models/customer';
import { DataService } from '../../../../../../_services/data.service';

@Component({
    selector: 'app-create-customer',
    templateUrl: './create-customer.component.html',
    encapsulation: ViewEncapsulation.None
})
export class CreateCustomerComponent extends BaseComponent implements OnInit {
    model: Customer = new Customer();

    constructor(
        private customerService: CustomerService,
        private dataService: DataService,
        private router: Router
    ) {
        super();
    }

    ngOnInit() {
        this.initPhoneMasks();
        this.initTaxMasks();
    }

    initPhoneMasks() {
        (<any>$('#phone')).inputmask({
            mask: '(999) 999 9999'
        });
    }

    initTaxMasks() {
        (<any>$('#taxNumber')).inputmask({
            mask: '99999999999'
        });
    }

    validate(event) {
        var customRules = this.validationService.customRules;
        return this.validationService.validate(event, {
            rules: {
                name: customRules.requiredText
            }
        });
    }

    createCustomer() {
        var _self = this;
        Helpers.setLoading(true);
        this.model.publisherId = this.dataService.publisherId;
        this.model.phone = (<any>$('#phone')).val();
        this.model.taxNumber = (<any>$('#taxNumber')).val();
        this.customerService.create(this.model).subscribe(res => {
            Helpers.setLoading(false);
            this.swalService.successCreate();
            this.model.name = '';
            setTimeout(function() {
                _self.router.navigate(['/publisher/customer/list']);
            }, 1000);
        });
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/publisher/customer/create-customer/create-customer.component.ts